import type {
  FootnoteSlot,
  MetalFootnote,
} from '~/scopes/campaign/data/metals/types'

// A leaf module rather than a home in `metals/index.ts` beside `metalBySlug`: that file
// imports all 35 metals, and the components that render a `<sup>` have no business pulling
// the whole registry in behind it.

/**
 * The client's own sequence: first note `*`, second `**`, third `***`. Positional, so it
 * can't drift from the order the notes are authored in — which is why `MetalFootnote` carries
 * no marker field. Legibility gives out around three; a fourth note is the cue to move to the
 * dagger sequence (`†`, `‡`), and this is the only line that would change.
 */
export const footnoteMarker = (index: number) => '*'.repeat(index + 1)

/**
 * `slot → marker`, so a host reads `markers[slot]` per slot instead of searching the notes for
 * each one. A slot claimed twice keeps the first note's marker — one `**` beside a score can't
 * stand for two explanations.
 */
export function footnoteSlotMarkers(footnotes: readonly MetalFootnote[]) {
  const markers: Partial<Record<FootnoteSlot, string>> = {}

  footnotes.forEach((footnote, index) =>
    footnote.slots?.forEach((slot) => {
      markers[slot] ??= footnoteMarker(index)
    }),
  )

  return markers
}
